var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 34,
    width: 28,
    height: 6,
    fill: "url(#paint0_radial_29871_21117)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 13.5C27.5 17.9469 25.2281 22.4458 22.4783 26.2499C19.7369 30.0424 16.5698 33.077 14.8816 34.5839C14.371 35.0396 13.629 35.0396 13.1184 34.5839C11.4302 33.077 8.26309 30.0424 5.52168 26.2499C2.77185 22.4458 0.5 17.9469 0.5 13.5C0.5 6.33728 6.52686 0.5 14 0.5C21.4731 0.5 27.5 6.33728 27.5 13.5Z",
    fill: "#EDEDED",
    stroke: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 13.665L21.4052 15.875C22.211 17.27 21.7327 19.0541 20.3385 19.8591C19.8943 20.115 19.3918 20.25 18.8802 20.25H17.161V21.9166L12.9943 19L17.161 16.0833V17.75H18.8793C18.9527 17.75 19.0243 17.7308 19.0877 17.6941C19.2652 17.5916 19.3385 17.3791 19.2718 17.1933L19.2402 17.125L17.9643 14.915L20.1293 13.665V13.665ZM10.2752 11.4033L10.7168 16.47L9.27518 15.6366L8.41518 17.125C8.37852 17.1883 8.35935 17.26 8.35935 17.3333C8.35935 17.5375 8.50685 17.7083 8.70102 17.7433L8.77602 17.75H11.3277V20.25H8.77602C7.16518 20.25 5.85935 18.9441 5.85935 17.3333C5.85935 16.8216 5.99435 16.3183 6.25018 15.875L7.10935 14.3866L5.66602 13.5533L10.2743 11.4033H10.2752ZM15.286 6.05746C15.7293 6.3133 16.0977 6.68163 16.3535 7.12496L17.2118 8.6133L18.656 7.77996L18.2143 12.8466L13.6043 10.6966L15.0477 9.8633L14.1885 8.37496C14.1518 8.31163 14.0993 8.2583 14.036 8.22246C13.8585 8.11996 13.6377 8.16246 13.5102 8.31413L13.4668 8.37496L12.1918 10.585L10.026 9.33496L11.301 7.12496C12.1068 5.72996 13.891 5.25163 15.286 6.05746V6.05746Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_29871_21117",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 37) rotate(90) scale(3 14)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141452",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/defaultIcon.6f402b14e6b866b45d5c65c00c09ea39.svg";
export { ForwardRef as ReactComponent };